export default function LogoMarquee() {
  const items = [
    "Local Home Services",
    "Med Spas & Aesthetics",
    "Real Estate Brokerages",
    "Fitness Studios",
    "Auto Dealers",
    "Dental Practices",
    "Coaches & Agencies",
    "E-commerce Brands",
  ];
  const doubled = [...items, ...items];
  return (
    <section
      data-testid="logo-marquee"
      className="py-6 border-y border-white/10 bg-[#0a0a0a] overflow-hidden no-scrollbar"
    >
      <div className="flex w-max marquee-track gap-12 px-6">
        {doubled.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-3 text-white/40 text-sm uppercase tracking-[0.18em] font-semibold whitespace-nowrap"
          >
            <span className="w-1.5 h-1.5 bg-[#ccff00] block" />
            {item}
          </div>
        ))}
      </div>
    </section>
  );
}
